<div class = "container">
    <div class="loading-overlay" *ngIf="loading">
        <mat-progress-spinner mode="indeterminate" diameter="40" strokeWidth="3"></mat-progress-spinner>
    </div>

    <form class = "card-form"  [formGroup]="motorForm" (ngSubmit)="submitForm()" autocomplete="off" novalidate>
        <div class="blue-top"></div>
        <div class="card-section top-section" *ngIf="enableAltView === false">
            <h1><b>{{pageHeading}}</b></h1>
            <!-- <h2>{{vehicleDetails}}</h2> -->

            <!-- <mat-form-field appearance="outline" class="form-select">
                <mat-label class="form-select-placeholder-unselected">
                    {{vehicleMakeLabel}}
                </mat-label>
                <mat-select formControlName="vehicleMake" (blur)="logErrors()" panelClass="form-select-popup" (selectionChange)="populateCarModelList()" [disabled]="carMakeIsEmpty">
                    <mat-option class="form-option" [value]="vehicleMakePlaceHolder" *ngFor="let vehicleMakePlaceHolder of VehicleMakePlaceHolders">
                        {{vehicleMakePlaceHolder}}
                    </mat-option>
                </mat-select>
                <span matPrefix *ngIf="loadingMake">
                    <mat-progress-spinner mode="indeterminate" diameter="15" strokeWidth="1"></mat-progress-spinner>
                </span>
                <mat-error *ngIf="formErrors['vehicleMake']">
                    {{formErrors['vehicleMake']}}
                </mat-error>
            </mat-form-field> -->

            <!-- <mat-form-field appearance="outline" class="form-select">
                <mat-label class="form-select-placeholder-unselected">
                    {{vehicleModelLabel}}
                </mat-label>
                <mat-select formControlName="vehicleModel"  panelClass="form-select-popup" (blur)="logErrors()" [disabled]="carModelsEmpty">
                    <mat-progress-bar *ngIf="loadingModel" mode="indeterminate"></mat-progress-bar>
                    <mat-option class="form-option" [value]="vehicleModelPlaceHolder" *ngFor="let vehicleModelPlaceHolder of VehicleModelPlaceHolders">
                        {{vehicleModelPlaceHolder}}
                    </mat-option>
                </mat-select>
                <span matPrefix *ngIf="loadingModel">
                    <mat-progress-spinner mode="indeterminate" diameter="15" strokeWidth="1"></mat-progress-spinner>
                </span>
                <mat-error *ngIf="formErrors['vehicleModel']">
                    {{formErrors['vehicleModel']}}
                </mat-error>
            </mat-form-field> -->

            <!-- <mat-form-field appearance="outline" class="form-select" appYearDateFormat>
                <mat-label class="form-select-placeholder-unselected">{{yearManufacturedLabel}}</mat-label>
                <input matInput [min]="minDate" [max]="maxDate" [matDatepicker]="dp" placeholder="" readonly="true" (click)="dp.open()" formControlName="yearManufactured">
                <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                <mat-datepicker #dp
                                startView="multi-year"
                                (yearSelected)="selectedYearHandler($event, dp)"
                                
                                panelClass="year-picker"
                                dateFormat>
                </mat-datepicker>
            </mat-form-field> -->
            
            <!-- <mat-form-field appearance="outline" class="form-select" *ngIf="hiddenFields === true">
                <mat-label class="form-select-placeholder-unselected">
                    {{passengersLabel}}
                </mat-label>
                <input matInput maxlength="2" spellcheck="false" formControlName="passengers" (blur)="logErrors()">
                <mat-error *ngIf="formErrors['passengers']">
                    {{formErrors['passengers']}}
                </mat-error>
            </mat-form-field> -->

            <!-- <mat-form-field appearance="outline" class="form-select" *ngIf="hiddenFields === true">
                <mat-label class="form-select-placeholder-unselected">
                    {{tonnageLabel}}
                </mat-label>
                <input [maxlength]="type === 'general' ? '1' : '2'" matInput class="right-align" spellcheck="false" formControlName="tonnage" (blur)="logErrors()">
                <mat-error *ngIf="formErrors['tonnage']">
                    {{formErrors['tonnage']}}
                </mat-error>
            </mat-form-field> -->
              
           <!--  <mat-form-field appearance="outline" class="form-select">
                <mat-label class="form-select-placeholder-unselected" >{{carValueLabel}}</mat-label>
                <input matInput spellcheck="false" formControlName="carValue" maxlength="22" (blur)="insurance === 'motorcycle' ? logErrorsMotorcycle() : logErrors()">
                <mat-error *ngIf="formErrors['carValue']">
                    {{formErrors['carValue']}}
                </mat-error>
            </mat-form-field> -->

            <!-- <div class="row-div"  *ngIf="showBenefits === false">
                <button mat-stroked-button type="button" (click)="confirmCancel()">
                    <span class="button-text">{{cancel}}</span>
                </button>
                <button mat-button type="submit" [disabled]="!motorForm.valid"> 
                    <span class="button-text">{{saveContinue}}</span>
                </button>
            </div> -->
        </div>
        <div class="card-section bottom-section" *ngIf="showBenefits === true">
            <h1 *ngIf="enableAltView"><b>{{pageHeading}}</b></h1>
            <h2>{{benefitsHeading}}</h2>
            
            <section class="benefits-section" formGroupName="benefits">
                <h3>{{benefitsSubheading}}</h3>
                <mat-checkbox formControlName="ownDamageProtector">
                    <p class="checkbox-p" [innerHTML]="protectorBenText | dompurify"></p>
                </mat-checkbox>
                <mat-checkbox formControlName="theftProtector">
                    <p class="checkbox-p" [innerHTML]="theftBenText | dompurify"></p>
                </mat-checkbox>
                <mat-checkbox formControlName="politicalViolence">
                    <p class="checkbox-p" [innerHTML]="politicalBenText | dompurify"></p>
                </mat-checkbox>
                <mat-checkbox formControlName="courtesyCar" *ngIf="insurance === 'private'">
                    <p class="checkbox-p" [innerHTML]="courCarBenText | dompurify"></p>
                </mat-checkbox>

                <section formGroupName="courtesyCarLimit" style="margin-bottom: 15px;" *ngIf="this.motorForm.controls['benefits'].controls['courtesyCar'].value" >
                    <div style="display: flex; width: 100%; align-items: center; justify-content: center;">
                        <div class="row-div modified_checkbox" style="width: 95%;">
                            <div class="row-inner-div row-inner-div-left">
                                <mat-checkbox formControlName="tenDays" (change)="onCourtesy10Change()">
                                {{ courtesy30kLabel }}
                                </mat-checkbox>
                            </div>
                            <div class="row-inner-div row-inner-div-right">
                                <mat-checkbox formControlName="twentyDays" (change)="onCourtesy20Change()">
                                {{ courtesy60kLabel }}
                                </mat-checkbox>
                            </div>
                        </div>
                    </div>
                    
                    <mat-hint *ngIf="!formGroupErrors['courtesyCarLimit']">{{ courtseyCarLimitDesc }}</mat-hint>
                    <mat-error *ngIf="formGroupErrors['courtesyCarLimit']" style="padding-left: 5px;">
                      {{formGroupErrors["courtesyCarLimit"]}}
                    </mat-error>

                </section>

                <mat-checkbox formControlName="passLiability" *ngIf="insurance === 'commercial'">
                    <p class="checkbox-p" [innerHTML]="passengerLiability | dompurify"></p>
                </mat-checkbox>

                <mat-checkbox formControlName="windscreen" (change)="clearWindscreenVal()" *ngIf="insurance !== 'motorcycle'">
                    <p class="checkbox-p" [innerHTML]="windBenText | dompurify"></p>
                </mat-checkbox>

                <div class="width-100pc" *ngIf="motorForm.controls['benefits'].controls['windscreen'].value === true">
                    <mat-form-field appearance="outline" class="form-select">
                        <mat-label class="form-select-placeholder-unselected" >{{windscreenAmountLabel}}</mat-label>
                        <input matInput spellcheck="false" formControlName="windscreenAmount" (blur)="logErrors()">
                        <mat-error *ngIf="formErrors['windscreenAmount']">{{formErrors['windscreenAmount']}}</mat-error>
                    </mat-form-field>
                </div>

                <mat-checkbox formControlName="entertainment" (change)="clearEntertainmentVal()" *ngIf="insurance !== 'motorcycle'">
                    <p class="checkbox-p" [innerHTML]="entBenText | dompurify"></p>
                </mat-checkbox>

                <div class="width-100pc" *ngIf="motorForm.controls['benefits'].controls['entertainment'].value === true">
                    <mat-form-field appearance="outline" class="form-select">
                        <mat-label class="form-select-placeholder-unselected" >{{entertainmentAmountLabel}}</mat-label>
                        <input spellcheck="false" matInput formControlName="entertainmentAmount" (blur)="logErrors()">
                        <mat-error *ngIf="formErrors['entertainmentAmount']">{{formErrors['entertainmentAmount']}}</mat-error>
                    </mat-form-field>
                </div>
            </section>

            <div class="row-div">
                <button mat-stroked-button type="button" (click)="confirmCancel()">
                    <span class="button-text">{{cancel}}</span>
                </button>
                <button mat-button type="submit" [disabled]="!motorForm.valid">
                    <span class="button-text">{{saveContinue}}</span>
                </button>
            </div>
        </div>
    </form>
</div>
